import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { QuestionPayload } from '../../types/questionPageTypings';

interface UpdateQuestionFunnelPageRequest {
  id: string;
  payload: QuestionPayload;
}

export function useTryToRequestUpdateQuestionPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: async ({ id, payload }: UpdateQuestionFunnelPageRequest) => {
      return await apiCancellationFunnels.tryToRequestUpdateCancellationFunnelPage(
        id,
        payload
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao editar o funil de Perguntas',
        'Ocorreu um erro ao editar o funil de Perguntas, por favor tente novamente mais tarde.'
      );
    },
  });

  return { tryToRequestUpdateQuestionPage: mutateAsync, isLoading };
}
